/* eslint-disable */

document.addEventListener('alpine:init', () => {
    Alpine.data('parallax', () => ({
        transNum: 0,
        direction: null,
        scrollEvent(num, direction = "vertical-up", enableDesktop = false, enableMobile = false) {
            const _self= this.$el;
            this.transNum = Number(num) ?? 0.5;
            this.direction = direction;

            window.addEventListener("scroll", () => {
                this.positionEvent(_self, enableDesktop, enableMobile);

                window.addEventListener("resize", () => {
                    this.positionEvent(_self, enableDesktop, enableMobile);
                });
            })
        },
        positionEvent(el, enableDesktop, enableMobile) {
            const wWidth = window.innerWidth;
            const negativeVal = ['down', 'right'];
            const { top } = el.getBoundingClientRect();
            const [ orientation, dir ] = this.direction.split("-");
            
            const axis = orientation === "vertical"? "Y" : "X";
            const multiplyOne = negativeVal.includes(dir)? -1 : 1;
            
            el.style[`backgroundPosition${axis}`] = ((enableDesktop && wWidth > 1024) || (enableMobile && wWidth < 1025)) ? `${top * (this.transNum * multiplyOne)}px` : "initial";
        }
    }));
});